<template>
    <div>
      <carousel :perPage="1" :paginationEnabled="false">
        <slide>
            <div class="padding">
            <p>I placed my hand on Oskas head and gently stroked his hair as he slept, his chest slowly rising and falling.</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p>I scooped my arm under his legs to lift him off the sofa and carry him upstairs, forgetting how heavy he is these days.</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p>I left the door to his room open and returned downstairs, i didn't want to turn on the stream, so I just sat and listened to the rain.</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p>Somehow I couldn't remember what I would normally do in the evenings, I couldn't remember what I did even before Oska.</p>
            </div>
        </slide>

        <slide>
            <div class="padding">
            <p>The room was silent.</p>
            </div>
        </slide>

      </carousel>
    </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'Rest'
    }
  },
  methods: {
  },
  mounted () {
    this.$emit('title-update', this.title)
  }
}
</script>

<style lang="css" scoped>
.VueCarousel-slide {
  height: 80vh;
}
</style>
